import axios from '@/core/http'

class Request {
  URL = ''
  axios = axios
}

export { Request }
